import useSWR from "swr";
import useSWRMutation from "swr/mutation";
import { mapRawToChipPos } from "@/mappers/chipPos";
import { RawChipPos, UploadChipPos } from "@/types/chipPos";
import { SWRApiError, swrConfigOptions, useDeleter, useFetcher, useUploader } from "./swr";

export const useChipPos = () => {
  const fetcher = useFetcher();

  const { data = [], ...rest } = useSWR<RawChipPos[], SWRApiError>(
    { url: "/chip_pos" },
    fetcher,
    swrConfigOptions,
  );

  return { data: data.filter(Boolean).map(mapRawToChipPos), ...rest };
};

export const useChipPosByMask = (maskId?: string) => {
  const fetcher = useFetcher();

  const { data = [], ...rest } = useSWR<RawChipPos[], SWRApiError>(
    maskId ? { url: `/chip_pos/mask/${maskId}` } : null,
    fetcher,
    swrConfigOptions,
  );

  return { data: data.filter(Boolean).map(mapRawToChipPos), ...rest };
};

export const useUploadChipPos = () => {
  const uploader = useUploader();

  return useSWRMutation<void, SWRApiError, string, UploadChipPos>("/chip_pos/upload", uploader);
};

export const useDeleteChipPos = () => {
  const deleter = useDeleter();

  return useSWRMutation<void, SWRApiError, string, { id: string }>("/chip_pos", deleter);
};
